export default class Collapse {
  constructor() {
    this.init();
  }

  init() {
    $('.aptim-collapse').on('click', function () {
      $(this).toggleClass('active');
    });
  }
}
